import React from 'react';
import { Logo as Logo$1 } from './Logo.styles.js';

function Logo(_a) {
  var logoImage = _a.logoImage;
  return React.createElement(Logo$1, null, logoImage);
}

export { Logo };